/* ── Card 01: AI recommendation picks ── */
function VisualRec() {
  return (
    <div className="ai-viz ai-viz--rec">
      <div className="avr-header">
        <span className="avr-live-dot" />
        Suggested for Table 7
      </div>
      <div className="avr-item avr-item--top">
        <span className="avr-name">Wagyu burger</span>
        <span className="avr-pick">✦ Top pick</span>
        <span className="avr-score">94%</span>
      </div>
      <div className="avr-item">
        <span className="avr-name">Burrata</span>
        <div className="avr-bar-wrap"><div className="avr-bar-fill" style={{ '--w': '78%' }} /></div>
        <span className="avr-pct">78%</span>
      </div>
      <div className="avr-item">
        <span className="avr-name">House red</span>
        <div className="avr-bar-wrap"><div className="avr-bar-fill" style={{ '--w': '61%' }} /></div>
        <span className="avr-pct">61%</span>
      </div>
    </div>
  );
}

/* ── Card 02: Live menu adaptation ── */
function VisualMenu() {
  return (
    <div className="ai-viz ai-viz--menu">
      <div className="avm-item avm-item--feat">
        <span className="avm-name">Wagyu ribeye</span>
        <span className="avm-tag avm-tag--feat">★ Featured</span>
      </div>
      <div className="avm-item avm-item--rise">
        <span className="avm-name">Smash burger</span>
        <span className="avm-tag avm-tag--rise">↑ Rising</span>
      </div>
      <div className="avm-item avm-item--out">
        <span className="avm-name">Lobster pasta</span>
        <span className="avm-tag avm-tag--out">Sold out</span>
      </div>
      <div className="avm-item">
        <span className="avm-name">Caesar salad</span>
        <span className="avm-tag">—</span>
      </div>
    </div>
  );
}

/* ── Card 03: Operator decisions / growth ── */
function VisualOps() {
  return (
    <div className="ai-viz ai-viz--ops">
      <div className="avo-chart">
        <svg viewBox="0 0 160 55" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <defs>
            <linearGradient id="avo-grad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#DDFA52" stopOpacity="0.18" />
              <stop offset="100%" stopColor="#DDFA52" stopOpacity="0" />
            </linearGradient>
          </defs>
          <polygon
            className="avo-area"
            points="0,50 32,40 64,30 96,20 128,12 160,5 160,55 0,55"
          />
          <path
            className="avo-line"
            d="M0,50 L32,40 L64,30 L96,20 L128,12 L160,5"
            pathLength="1"
          />
          <circle className="avo-dot" cx="160" cy="5" r="2.5" />
        </svg>
      </div>
      <div className="avo-recs">
        <span className="avo-rec avo-rec--drop">DROP ↓  Lobster pasta</span>
        <span className="avo-rec avo-rec--feat">FEATURE ↑  Wagyu burger</span>
        <span className="avo-rec avo-rec--test">TEST →  Friday pricing</span>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   CARD DATA
══════════════════════════════════════════════ */

const CARDS = [
  {
    num: '01',
    title: (
      <>
        Recommendations
        <br />
        that <em>convert.</em>
      </>
    ),
    body: 'Per-guest item suggestions based on time-of-day, table history, and current kitchen load. Quiet upsell, never pushy.',
    tag: 'Guest-side AI',
    Visual: VisualRec,
  },
  {
    num: '02',
    title: (
      <>
        Menus that <em>adapt.</em>
      </>
    ),
    body: 'Dynamic menu state by time, demand, weather, and event. Sold-out items vanish. High-margin items rise. Automatically.',
    tag: 'Menu engine',
    Visual: VisualMenu,
  },
  {
    num: '03',
    title: (
      <>
        Decisions that <em>compound.</em>
      </>
    ),
    body: 'Continuous menu & pricing optimization that learns from every cover. Recommends what to drop, what to feature, what to test next week.',
    tag: 'Operator AI',
    Visual: VisualOps,
  },
];

export default function AISection() {
  return (
    <section className="ai" id="ai">
      <div className="ai-inner">
        <div className="kicker reveal">
          <span className="kicker-dot" />
          <span>Quiet intelligence</span>
        </div>
        <h2 className="display ai-title reveal-words">
          A platform that <em>thinks</em>
          <br />
          in covers, costs, and
          <br />
          <span className="ai-rotator">
            <span className="ai-rotator-track">
              <span className="ai-w">
                <em>conversions.</em>
              </span>
              <span className="ai-w">
                <em>cravings.</em>
              </span>
              <span className="ai-w">
                <em>crowds.</em>
              </span>
            </span>
          </span>
        </h2>
        <p className="lede reveal">
          Three intelligence layers running quietly underneath every shift —
          surfacing the moves that actually move the bottom line.
        </p>

        <div className="ai-grid">
          {CARDS.map((card) => (
            <article className="ai-card reveal" key={card.num}>
              <div className="ai-card-num">{card.num}</div>
              <h4 className="display">{card.title}</h4>
              <p>{card.body}</p>
              <card.Visual />
              <div className="ai-card-tag">{card.tag}</div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
